import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/dsk-payment-provider/:id/';

interface DTO {
    parkingId: string;
    id: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, id }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, id }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteDSKPaymentProvider };
export type { DTO as DeleteDSKPaymentProvider };
